import { Component, inject } from '@angular/core';
import { TakeUntilDestroy } from '@app/shared/decorators/take-until-destroy.decorator';
import { User } from '@app/shared/models/user.model';
import { LoggerService } from '@app/shared/services/logger.service';
import { AppService } from '@app/app.service';
import { AppReviewService } from '@shared/services/app-review.service';
import { ButtonComponent } from '@app/shared/components/button/button.component';
import { SharedModule } from '@app/shared/shared.module';
import { UserRepository } from '@app/shared/state/user/user.repository';

@TakeUntilDestroy
@Component({
  selector: 'slotcom-update-version-modal',
  templateUrl: './update-version.component.html',
  styleUrls: ['./update-version.component.scss'],
  standalone: true,
  imports: [ButtonComponent, SharedModule],
})
export class UpdateVersionModalComponent {
  logger = inject(LoggerService);
  private userRepo = inject(UserRepository);
  private appReviewService = inject(AppReviewService);
  private appService = inject(AppService);

  user: User = this.userRepo.getUser();
  isForceUpdate = true;

  redirectToStore() {
    this.appReviewService.openStore().catch((e) => this.logger.error(e));
    this.closeModal();
  }

  closeModal() {
    this.appService.reload();
  }
}
